<template>
 <div class="commentDetail" >
	<topTitle title="评价"></topTitle>
	<!-- <div class="commentTab" >
		<button :class="{active : activety == 1  }"  @click="commentBtn(1)" >全部</button>
		<button :class="{active : activety == 2 }" @click="commentBtn(2)" >好评</button>
		<button :class="{active : activety == 3 }" @click="commentBtn(3)"  >中评</button>
		<button :class="{active : activety == 4 }" @click="commentBtn(4)"  >差评</button>
		<button :class="{active : activety == 5 }" @click="commentBtn(5)"  >有图</button>
	</div> -->
	<div class="commentBox" >
		<div class="commentList" >
			<div class="cmListTop" v-for="(item,i) in commentListData" :key="i" >
				<div class="clearfix" >
					<img class="cmPhoto" :src="item.member_face" alt="">
					<div class="cmUserName" >
						<span>{{item.member_name}}</span>
						<i>{{item.create_time}}</i>
					</div>
				</div>
				<div class="commentContent" >
					<p>{{item.content}}</p>
					<div class="cmImg" >
                        <img v-for="(obj,index) in item.images" :src='obj' :key="index" alt="" @click="imageShow(item,i)" >
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="commentList" >
			<div class="cmListTop " >
				<div class="clearfix" >
					<img class="cmPhoto" src="../../assets/img/tmp/goodsDetail/photoEvaluate.png" alt="">
					<div class="cmUserName" >
						<span>购买用户品的用户名</span>
						<i>2019-12-02</i>
					</div>
				</div>
				<div class="commentContent" >
					<p>好喜欢这个衣服，大气，不掉色，手感柔软，不气球，好高兴，闺蜜看到我穿也非常喜欢，推荐给闺蜜。</p>
				</div>
			</div>
		</div> -->
		<!-- 无评价显示 -->
		<!-- <div class="noComment" >
 				<img class="noCommentImg" src="../../assets/img/default/noComment.png" alt="">
				<p class="noCommentText" >暂无评价</p>
		</div> -->
		<van-image-preview v-model="showImgP" :images="commentImg.images" :startPosition='startPosi'  @change="onChange">
			<template v-slot:cover>
				<div class="slotComment" >
					<p>{{commentImg.content}}</p>
				</div>	
			</template>
		</van-image-preview>
	</div>
 </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
export default {
  name: 'commentDetail',
  data() {
    return {
		// activety:1,
		startPosi:1,
		showImgP:false,
		shopId:this.$route.query.goods_id,
		commentListData:[],
		commentImg:{},
		images: [
			     '/img/goosDetailimg.b8889047.png',
		         '/img/goosDetailimg.b8889047.png',
		  ],
		page_no: 1,
		page_size:5,
		loading:true,
		finished: false,
    }
  },
  components: {
	topTitle
  },
  mounted(){
	  this.getCommentList();
  },
  methods: {
	  onLoad(){
				this.page_no = this.page_no + 1;
     			this.getCommentList();
			},
		  async	getCommentList(){
              this.getRequest( `members/comments/goods/${this.shopId}`,{page_no:this.page_no,page_size:this.page_size}).then(res => {
			   this.commentListData = this.commentListData.concat(res.data.data.data)
			    this.loading = false;
			   console.log(res.data.data.data);
			   if (res.data.data.data.length < 5) {
					this.finished = true;
				}
			})
			},
  	 commentBtn(n){
	  	this.activety = n;
	  },
	 onChange(index) {
     	 this.index = index;
	},
	imageShow(item,i){
	   this.startPosi = i;
	   this.showImgP = true;
	   this.commentImg  = item;
	}
	
  }
}
</script>

<style scoped lang='less'>
	.clearfix{
		zoom: 1;
		&::after{
			content: "\20";
			height: 0;
			display: block;
			clear: both;
		}
	}
.commentDetail{
	.commentTab{
		padding:36px 20px;
		background-color: #fff;
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 20px;
		button{
			width:158px;
			height:52px;
			background:rgba(253,242,241,1);
			border-radius:26px;
			text-align: center;
			line-height: 55px;
			color: #666666;
			font-size: 24px;
			margin-bottom:20px;
			margin-right: 20px;
		}
		button:nth-child(4){
			margin-right: 0;
		}
		button.active{
			background:rgba(253,242,241,1);
			border:2px solid rgba(255,25,25,1);
			color: #FF1919;
		}
	}
	.commentBox{
		padding: 30px;
		background-color: #fff;
		.commentList{
			margin-bottom: 30px;
			padding: 20px 0;
			.cmListTop{
				.cmPhoto{
					width: 56px;
					height: 56px;
					border-radius: 50%;
					margin-right: 24px;
					float: left;
				}
				.cmUserName{
					float: left;
					span{
						color: #999999;
						font-size: 26px;
						display: block;
						margin-bottom: 5px;
					}
					i{
						font-style: normal;
						color: #999;
						font-size: 26px;
					}
				}
				.commentContent{
					margin-left:80px;
					color: #333333;
					font-size: 26px;
					line-height:37px;
					margin-top: 16px;
					.cmImg{
						display: flex;
						flex-wrap: wrap;
						margin-top: 20px;
						img{
							width: 194px;
							height: 194px;
							margin-right:8px;
							margin-bottom: 8px;
						}
						img:nth-child(3n){
							margin-right: 0;
						}
					}
				}
			}
		}
		.noComment{
          .noCommentImg{
					 width: 200px;
					 height: 138px;
					 margin:0px auto;
					 margin-top: 30px;
				 }
				 .noCommentText{
					 color: #CCCCCC;
					 font-size: 26px;
					 text-align: center;
				 }
		}
		/deep/ .van-image-preview__cover{
			width: 100%;
			top: initial;
			.slotComment{
				position: absolute;
				bottom: 0;
				padding: 30px;
				p{
					color: #fff;
					font-size: 26px;
				}
			}
		}
	}
}

	
</style>

